const getters = {
  api_id: state => state.user.api_id,
  roles: state => state.user.roles,
}
export default getters